'use client';

import PageHeader from './components/PageHeader';
import SectionHeading from './components/SectionHeading';
import Button from './components/Button';
import ArrowleftIcon from './components/ArrowLeftIcon';
import Footer from './components/Footer';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();
  return (
    <div className="container notFoundContainer">
      <div className="box">
        <PageHeader />
        <SectionHeading
          heading="The requested page was not found"
          subheading="The page you're looking for doesn't exist. You may have mistyped the address or the page has been moved."
        />
        <Button
          icon={<ArrowleftIcon />}
          size="sm"
          type="button"
          onClick={() => router.push('/')}
          variant="secondary"
        >
          Go home
        </Button>
      </div>
      <Footer />
    </div>
  );
}
